mutation activateUser(
  $baseSiteId: BaseSiteId!
  $token: String!
  $lang: String
  $division: String
  $distributionChannel: String
) {
  activateUser(
    baseSiteId: $baseSiteId
    token: $token
    lang: $lang
    division: $division
    distributionChannel: $distributionChannel
  ) {
    success
    messages
  }
}
